import { useState } from "react"
import { Flex, Box, Text } from "rebass"
import Slider from "rc-slider"

const DataSlider = ({
  text,
  desc,
  numSteps,
  scaleFactor,
  mbsPerUnit,
  setTotal,
  total,
  dataKey,
  time,
  ...props
}) => {
  function generateMarks(scaleFactor, numSteps) {
    let marks = {}
    for (let i = 0; i <= numSteps; i++) {
      marks[i] = pow2(i - 1) * scaleFactor
    }
    return marks
  }

  function generateMarksHours(scaleFactor, numSteps) {
    let marks = {}
    for (let i = 0; i <= numSteps; i++) {
      let mins = pow2(i - 1) * scaleFactor
      if (mins < 60) {
        marks[i] = `${mins} mins`
      } else {
        marks[i] = {
          label: `${mins / 60} hrs`,
        }
      }
    }
    return marks
  }

  function pow2(n) {
    return Math.floor(Math.pow(2, n))
  }

  function totalByType(scaleFactor, mbsPerUnit, n) {
    return scaleFactor * pow2(n - 1) * mbsPerUnit * 30
  }

  return (
    <Box m={2} p={2} mt={0}>
      <Slider
        min={0}
        max={numSteps + 1}
        marks={
          time
            ? generateMarksHours(scaleFactor, numSteps)
            : generateMarks(scaleFactor, numSteps)
        }
        onAfterChange={(v) =>
          setTotal({
            ...total,
            [dataKey]: totalByType(scaleFactor, mbsPerUnit, v),
          })
        }
        {...props}
      />
    </Box>
  )
}

export default DataSlider
